import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'

export const BrainstormIdeas = (props: LevelProps) => {
  return <LevelPage {...props} imgScale={0.45} textWidth="60%" cards={LEVEL_CARDS.L2.BRAINSTORM_IDEAS} />
}
